// 法语餐饮常用词
// 共 265 个单词

export default [
  {
    id: 1,
    word: "abalone",
    phonetic: "[abal\u0254n]",
    type: "",
    translation: "n.m. \u9c8d\u9c7c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 2,
    word: "abricot",
    phonetic: "[abriko]",
    type: "",
    translation: "n.m. \u674f\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 3,
    word: "acide",
    phonetic: "[asid]",
    type: "",
    translation: "a. \u9178\u7684\uff1b\u5c16\u9178\u7684\uff0c\u523b\u8584\u7684\uff1bn.m. [\u5316]\u9178",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 4,
    word: "ail",
    phonetic: "[aj]",
    type: "",
    translation: "n.m. \u5927\u849c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 5,
    word: "alcool",
    phonetic: "[alk\u0254l]",
    type: "",
    translation: "n.m. \u9152\u7cbe\uff1b\u767d\u9152\uff1b\u9152\u7cbe\u5ea6\u9ad8\u7684\u996e\u6599\uff1b \u9187;\u4e59\u9187",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 6,
    word: "aliments",
    phonetic: "[alim\u0251\u0303]",
    type: "",
    translation: "\u98df\u7269\uff1b \u7cae\u98df\uff1b \u6c34\u8c37",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 7,
    word: "amande",
    phonetic: "[am\u0251\u0303d]",
    type: "",
    translation: "n.f. \u5df4\u65e6\u674f\u4ec1\uff1b\u6838\u679c\u7684\u79cd\u4ec1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 8,
    word: "amer",
    phonetic: "[am\u03b5r]",
    type: "",
    translation: "a. \u82e6\u7684\uff0c\u82e6\u6da9\u7684\uff1b\u75db\u82e6\u7684\uff0c\u8f9b\u9178\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 9,
    word: "amuse-gueule",
    phonetic: "[amyzg\u0153l]",
    type: "",
    translation: "n.m. \u5f00\u80c3\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 10,
    word: "ananas",
    phonetic: "[anana(s)]",
    type: "",
    translation: "n.m. \u83e0\u841d\uff0c\u51e4\u68a8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 11,
    word: "anchois",
    phonetic: "[\u0251\u0303\u222bwa]",
    type: "",
    translation: "n.m. \u9cc0\u9c7c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 12,
    word: "anguille",
    phonetic: "[\u0251\u0303gij]",
    type: "",
    translation: "n.f. \u9cd7\u9c7c\uff0c \u9cdd\u9c7c\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 13,
    word: "arachide",
    phonetic: "[ara\u222bid]",
    type: "",
    translation: "n.f. \u82b1\u751f\uff0c\u843d\u82b1\u751f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 14,
    word: "arbouse",
    phonetic: "[arbuz]",
    type: "",
    translation: "n.f. \u91ce\u8349\u8393",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 15,
    word: "aubergine",
    phonetic: "[ob\u03b5r\u0292in]",
    type: "",
    translation: "n.f. \u8304\uff1b\u8304\u5b50\uff1ba. inv. \u6df1\u7d2b\u8272\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 16,
    word: "avocat",
    phonetic: "[av\u0254ka, -t]",
    type: "",
    translation: "n. \u5f8b\u5e08\uff1b\u725b\u6cb9\u679c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 17,
    word: "azerole",
    phonetic: "[azr\u0254l]",
    type: "",
    translation: "n.f. \u610f\u5927\u5229\u5c71\u6942",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 18,
    word: "banane",
    phonetic: "[banan]",
    type: "",
    translation: "n.f. \u9999\u8549",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 19,
    word: "banquet",
    phonetic: "[b\u0251\u0303k\u03b5]",
    type: "",
    translation: "n.m. 1.\u5bb4\u4f1a\uff1b2.\u679c\u5b9e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 20,
    word: "beignet",
    phonetic: "[b\u03b5\u0272\u03b5]",
    type: "",
    translation: "n.m. \uff08\u5e26\u9985\u7684\uff09\u70b8\u7cd5\uff0c\u714e\u997c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 21,
    word: "betterave",
    phonetic: "[b\u03b5tra:v]",
    type: "",
    translation: "n.f. \u98df\u7528\u751c\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 22,
    word: "beurre",
    phonetic: "[b\u0153r]",
    type: "",
    translation: "n.m. \u9ec4\u6cb9\uff1b\u690d\u7269\u6cb9\u8102",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 23,
    word: "bi\u00e8re",
    phonetic: "[bj\u03b5r]",
    type: "",
    translation: "n.f. \u5564\u9152",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 24,
    word: "biscuit",
    phonetic: "[bisk\u0265i]",
    type: "",
    translation: "n.m. \u997c\u5e72\uff1b\u5c0f\u5706\u997c\uff1b\u7d20\u576f\u74f7\uff0c\u672c\u8272\u74f7\uff0c\u767d\u74f7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 25,
    word: "bl\u00e9",
    phonetic: "[ble]",
    type: "",
    translation: "n.m. \u5c0f\u9ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 26,
    word: "b\u0153uf",
    phonetic: "[b\u0153f]",
    type: "",
    translation: "n.m. \u725b\uff0c\u516c\u725b\uff1b\u725b\u8089",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 27,
    word: "boire",
    phonetic: "[bwar]",
    type: "",
    translation: "v.t. \u559d\uff0c\u996e\uff1b\u5438\u6536",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 28,
    word: "boisson",
    phonetic: "[bwas\u0254\u0303]",
    type: "",
    translation: "n.f. \u996e\u6599\uff1b\u9152\uff0c\u542b\u9152\u7cbe\u996e\u6599",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 29,
    word: "bonbon",
    phonetic: "[b\u0254\u0303b\u0254\u0303]",
    type: "",
    translation: "n.m. \u7cd6\u679c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 30,
    word: "boucherie",
    phonetic: "[bu\u222bri]",
    type: "",
    translation: "n.f. \u9c9c\u8089\u4e1a\uff1b\u8089\u5e97\uff1b\u5c60\u6740",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 31,
    word: "bouillir",
    phonetic: "[bujir]",
    type: "",
    translation: "v.i. \u6cb8\u6eda\uff0c\u6cb8\u817e\uff1b\u5728\u5f00\u6c34\u91cc\u70eb\uff0c\u5728\u6cb8\u6eda\u7684\u6db2\u4f53\u4e2d\u716e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 32,
    word: "boulette",
    phonetic: "[bul\u03b5t]",
    type: "",
    translation: "n.f. \u5c0f\u56e2\uff0c\u5c0f\u7403\uff1b\u4e38\u5b50\uff0c\u5c0f\u9762\u56e2\uff1b\u5dee\u9519\uff0c\u758f\u5ffd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 33,
    word: "brocoli",
    phonetic: "[br\u0254k\u0254li]",
    type: "",
    translation: "n.m. \u82b1\u830e\u7518\u84dd\uff0c \u82b1\u6930\u83dc\uff1b\u540c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 34,
    word: "cacahu\u00e8te",
    phonetic: "[kakaw\u03b5t, -\u0265\u03b5t]",
    type: "",
    translation: "\u82b1\u751f\uff08\u6307\u679c\u5b9e\uff09\uff0c\u82b1\u751f\u4ec1\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 35,
    word: "cacao",
    phonetic: "[kakao]",
    type: "",
    translation: "n.m. \u53ef\u53ef\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 36,
    word: "caf\u00e9",
    phonetic: "[kafe]",
    type: "",
    translation: "n.m. \u5496\u5561\u8c46\uff1b\u5496\u5561\uff1b\u5496\u5561\u9986",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 37,
    word: "canard",
    phonetic: "[kanar]",
    type: "",
    translation: "n.m. \u9e2d\uff0c\u96c4\u9e2d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 38,
    word: "cantine",
    phonetic: "[k\u0251\u0303tin]",
    type: "",
    translation: "n.f. \u98df\u5802\uff0c\u996d\u5385\uff1b\u65c5\u884c\u7bb1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 39,
    word: "carotte",
    phonetic: "[kar\u0254t]",
    type: "",
    translation: "n.f. \u80e1\u841d\u535c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 40,
    word: "carpe",
    phonetic: "[karp]",
    type: "",
    translation: "n.f.\uff0c n.m. \u8155\uff1b\u9ca4\u9c7c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 41,
    word: "casse-cro\u00fbte",
    phonetic: "[kaskrut]",
    type: "",
    translation: "n.m. \u5feb\u9910\u98df\u54c1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 42,
    word: "c\u00e9leri",
    phonetic: "[s\u025blri]",
    type: "",
    translation: "n.m. \u82b9\u83dc\uff0c\u65f1\u82b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 43,
    word: "c\u00e9r\u00e9ales",
    phonetic: "[sereal]",
    type: "",
    translation: "\u8c37\u7269\uff0c \u7cae\u98df 1 of 7 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 44,
    word: "cerise",
    phonetic: "[s(\u0259)riz]",
    type: "",
    translation: "n.f. \u6a31\u6843",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 45,
    word: "champignon",
    phonetic: "[\u222b\u0251\u0303pi\u0272\u0254\u0303]",
    type: "",
    translation: "n.m. \u8611\u83c7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 46,
    word: "ch\u00e8vre",
    phonetic: "[\u222b\u03b5vr]",
    type: "",
    translation: "n.f. 1.\u5c71\u7f8a\uff0c\u5c71\u7f8a\u76ae 2.\u5c71\u7f8a\u5976\u916a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 47,
    word: "chou",
    phonetic: "[\u222bu]",
    type: "",
    translation: "n.m. \u7518\u84dd\uff0c\u5377\u5fc3\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 48,
    word: "chou-fleur",
    phonetic: "[\u222bufl\u0153r]",
    type: "",
    translation: "n.m. \u82b1\u6930\u83dc\uff0c \u82b1\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 49,
    word: "ciboule",
    phonetic: "[sibul]",
    type: "",
    translation: "n.f. \u8471",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 50,
    word: "ciboulette",
    phonetic: "[sibul\u03b5t]",
    type: "",
    translation: "n.f. \u7ec6\u9999\u8471\uff0c \u5c0f\u8471",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 51,
    word: "citron",
    phonetic: "[sitr\u0254\u0303]",
    type: "",
    translation: "n.m. \u67e0\u6aac\uff1ba. inv. \u6de1\u9ec4\u8272\u7684\uff0c\u67e0\u6aac\u9ec4\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 52,
    word: "citronnade",
    phonetic: "[sitr\u0254nad]",
    type: "",
    translation: "n.f. \u67e0\u6aac\u6c34\uff0c\u67e0\u6aac\u6c7d\u6c34",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 53,
    word: "citrouille",
    phonetic: "[sitruj]",
    type: "",
    translation: "n.f. \u5357\u74dc\uff1b\u897f\u846b\u82a6\uff1b\u8111\u888b\uff0c\u5927\u5934",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 54,
    word: "cochon",
    phonetic: "[k\u0254\u222b\u0254\u0303]",
    type: "",
    translation: "n.m. \u732a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 55,
    word: "compote",
    phonetic: "[k\u0254\u0303p\u0254t]",
    type: "",
    translation: "n.f. \u679c\u6ce5\uff1b \u679c\u7cca",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 56,
    word: "concombre",
    phonetic: "[k\u0254\u0303k\u0254\u0303br]",
    type: "",
    translation: "n.m. \u9ec4\u74dc n.f. \u7cd6\u679c\u871c\u996f\u4e1a\uff0c\u751c\u98df\u4e1a\uff1b\u7cd6\u679c\u871c\u996f\u5e97\uff1b\u7cd6\u679c\u871c\u996f\u5382\uff1b\u7cd6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 57,
    word: "confiserie",
    phonetic: "[k\u0254\u0303fizri]",
    type: "",
    translation: "\u679c\uff0c\u871c\u996f\uff0c\u751c\u98df",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 58,
    word: "confiture",
    phonetic: "[k\u0254\u0303fityr]",
    type: "",
    translation: "n.f. \u679c\u9171",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 59,
    word: "coq",
    phonetic: "[k\u0254k]",
    type: "",
    translation: "n.m. \u516c\u9e21\uff0c\u96c4\u9e21",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 60,
    word: "coriandre",
    phonetic: "[k\u0254rj\u0251\u0303dr]",
    type: "",
    translation: "n.f. \u82ab\u837d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 61,
    word: "c\u00f4telette",
    phonetic: "[kotl\u03b5t]",
    type: "",
    translation: "n.f. \u6392\u9aa8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 62,
    word: "courge",
    phonetic: "[kur\u0292]",
    type: "",
    translation: "n.f. \u7b0b\u74dc\uff1b\u5357\u74dc\uff1b\u897f\u846b\u82a6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 63,
    word: "crabe",
    phonetic: "[krab]",
    type: "",
    translation: "n.m. \u87f9 n.f. \u5976\u6cb9\uff0c\u4e73\u6cb9\uff1b\u9999\u8102\uff0c\u4e73\u818f\uff1ba. inv. \u4e73\u767d\u8272\u7684\uff0c\u6d45\u9ec4\u8272",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 64,
    word: "cr\u00e8me",
    phonetic: "[kr\u03b5m]",
    type: "",
    translation: "\u7684\uff0c\u7c73\u8272\u7684 n.m. \u7ec9\u7eb1\uff0c\u7ec9\u7ef8\uff0c\u7ec9\u5e03\uff0c\u7ec9\u5462\uff1b\uff08\u4e27\u4e8b\u7528\u7684\uff09\u9ed1\u7eb1\uff1bn.f.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 65,
    word: "cr\u00eape",
    phonetic: "[kr\u03b5p]",
    type: "",
    translation: "\u8584\u997c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 66,
    word: "crevette",
    phonetic: "[kr\u0259v\u03b5t]",
    type: "",
    translation: "n.f. \u867e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 67,
    word: "\u00e9crevisse",
    phonetic: "[ekr\u0259vis]",
    type: "",
    translation: "n.f. \u87af\u867e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 68,
    word: "cuire",
    phonetic: "[k\u0265ir]",
    type: "",
    translation: "v.t. \u70e7\uff0c\u716e\uff0c\u7116\uff1b\u70d8\uff0c\u70e4\uff1b\u84b8\uff1b\u7119\u70e7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 69,
    word: "cuisine",
    phonetic: "[k\u0265izin]",
    type: "",
    translation: "n.f. \u53a8\u623f\uff1b\u70f9\u8c03\uff0c\u70f9\u996a\uff1b\u70f9\u996a\u6cd5\uff1b\u83dc\u80b4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 70,
    word: "daurade",
    phonetic: "[d\u0254rad]",
    type: "",
    translation: "n.f. \u9ec4\u9c7c\uff0c\u9ec4\u82b1\u9c7c\uff0c\u9cb7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 71,
    word: "d\u00e9licieux",
    phonetic: "[delisj\u00f8]",
    type: "",
    translation: "a. \u4ee4\u4eba\u975e\u5e38\u5feb\u4e50\u7684\uff1b\u53ef\u53e3\u7684\uff0c\u7f8e\u5473\u7684\uff1b\u82ac\u82b3\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 72,
    word: "eau",
    phonetic: "[o]",
    type: "",
    translation: "n.f. \u6c34\uff1b\u6d77\uff1b\u6e56\uff1b\u6cb3\uff1b\u6c60\u5858\uff1b\u836f\u6c34\uff1b\u6eb6\u6db2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 73,
    word: "robinet",
    phonetic: "[r\u0254bin\u03b5]",
    type: "",
    translation: "n.m.\uff08\u6d41\u4f53\u7684\uff09\u5f00\u5173\uff0c\u9f99\u5934\uff1b\u9600 n.f. \u70ed\u7684\uff0c\u6696\u7684\uff0c\u70eb\u7684\uff1b\u4fdd\u6696\u7684\uff1b\u708e\u70ed\u7684\uff0c\u53d1\u70ed\u7684\uff0c\u53d1\u70eb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 74,
    word: "chaude",
    phonetic: "[\u0283o:d]",
    type: "",
    translation: "\u7684\uff1b\u70ed\u60c5\u7684\uff0c\u6fc0\u60c5\u7684\uff1b\u6025\u8e81\u7684\uff1b\u70ed\u70c8\u7684\uff0c\u6fc0\u70c8\u7684\uff0c\u5f3a\u70c8 \u7684\uff1b\u6700\u8fd1\u7684\uff0c\u65b0\u8fd1\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 75,
    word: "potable",
    phonetic: "[p\u0254tabl]",
    type: "",
    translation: "adj. \u53ef\u996e\u7684\uff1b\u8fd8\u53ef\u4ee5\u7684 adj. \u9999\u6599\u52a0\u591a\u4e86\u7684\uff0c \u8f9b\u9999\u4f5c\u6599\u52a0\u591a\u4e86\u7684\uff0c \u8f9b\u8fa3\u7684\uff1b\u8f7b\u4f7b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 76,
    word: "\u00e9pic\u00e9",
    phonetic: "[epise]",
    type: "",
    translation: "\u7684\uff0c \u8272\u60c5\u7684\uff0c \u8f7b\u6d6e\u7684\uff0c \u7325\u4eb5\u7684[\u6307\u6545\u4e8b\uff0c \u8c08\u8bdd]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 77,
    word: "\u00e9picerie",
    phonetic: "[episri]",
    type: "",
    translation: "n.f.\uff08\u98df\u54c1\uff09\u6742\u8d27\u4e1a\uff1b\uff08\u98df\u54c1\uff09\u6742\u8d27\u5e97",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 78,
    word: "\u00e9pinard",
    phonetic: "[epinar]",
    type: "",
    translation: "n.m. \u83e0\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 79,
    word: "frire",
    phonetic: "[frir]",
    type: "",
    translation: "v.t. \u6cb9\u70b8\uff0c\u6cb9\u6c3d\uff0c\u6cb9\u714e\uff1bv.i. \u5728\u6cb9\u4e2d\u70b8\uff0c\u5728\u6cb9\u4e2d\u714e v.\u8df3\uff0c\u8df3\u8dc3\uff1b\u731b\u6251\uff0c\u6251\u4e0a\u53bb\uff1b\u8e66\u6389\uff0c\u98de\u6389\uff1b\u7206\u70b8\uff0c\u70b8\u6bc1\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 80,
    word: "sauter",
    phonetic: "[sote]",
    type: "",
    translation: "\u8df3\u8fc7\uff0c \u8df3\u8d8a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 81,
    word: "farine",
    phonetic: "[farin]",
    type: "",
    translation: "n.f. \u8c37\u7269\u78e8\u6210\u7684\u7c89\uff0c\u9762\u7c89",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 82,
    word: "f\u00e8ve",
    phonetic: "[f\u03b5v]",
    type: "",
    translation: "n.f. \u8695\u8c46\uff1b\u67d0\u4e9b\u548c\u8695\u8c46\u76f8\u4f3c\u7684\u8c46\u7c7b\uff1b\u86f9\uff1b\uff08\u9a6c\uff09\u4e0a\u816d\u80bf\u80c0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 83,
    word: "l\u00e9gumineuse",
    phonetic: "[legymin\u00f8z]",
    type: "",
    translation: "\u3010\u690d\u7269\u5b66\u3011\u957f\u835a\u679c\u7684\uff1bpl.\u8c46\u79d1\u690d\u7269 2 of 7 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 84,
    word: "figue",
    phonetic: "[fig]",
    type: "",
    translation: "n.f. \u65e0\u82b1\u679c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 85,
    word: "foie",
    phonetic: "[fwa]",
    type: "",
    translation: "n.m. \u809d\uff0c\u809d\u810f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 86,
    word: "fraise",
    phonetic: "[fr\u03b5z]",
    type: "",
    translation: "n.f. \u8349\u8393",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 87,
    word: "caill\u00e9",
    phonetic: "[kaje]",
    type: "",
    translation: "n.m. \u51dd\u4e73\uff1b\u5e72\u916a\u7d20",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 88,
    word: "lait",
    phonetic: "[l\u03b5]",
    type: "",
    translation: "n.m. \u4e73\uff0c\u5976\uff1b\u4e73\u72b6\u6db2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 89,
    word: "fromage",
    phonetic: "[fr\u0254ma:\u0292]",
    type: "",
    translation: "n.m. \u5e72\u916a\uff0c\u5976\u916a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 90,
    word: "tofu",
    phonetic: "[t\u0254fu]",
    type: "",
    translation: "n.m. \u8c46\u8150",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 91,
    word: "fruit",
    phonetic: "[fr\u0265i]",
    type: "",
    translation: "n.m. \u6c34\u679c\uff1b\u679c\u5b9e\uff1b\u7ed3\u679c\uff0c\u6210\u679c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 92,
    word: "galette",
    phonetic: "[gal\u03b5t]",
    type: "",
    translation: "n.f. \u997c\uff0c\u70d9\u997c\uff0c\u714e\u997c\uff1b\u9ec4\u6cb9\u86cb\u7cd5\uff0c\u751c\u7cd5\u70b9 adj. \u8c37\u86cb\u767d\u7684\uff0c \u9762\u7b4b\u7684\uff1b\u542b\u8c37\u86cb\u767d\u7684\uff0c \u542b\u9762\u7b4b\u7684\uff1b\u7c98",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 93,
    word: "glutineux",
    phonetic: "[glytin\u00f8]",
    type: "",
    translation: "\u7684\uff0c \u7c98\u6027\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 94,
    word: "g\u00e9sier",
    phonetic: "[\u0292ezje]",
    type: "",
    translation: "n.m. \uff08\u79bd\u7c7b\u7684\uff09\u7802\u56ca\uff0c \u80ab\uff1b\u80c3\uff1b \u809a\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 95,
    word: "gingembre",
    phonetic: "[\u0292\u025b\u0303\u0292\u0251\u0303br]",
    type: "",
    translation: "n.m. \u59dc\uff0c\u751f\u59dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 96,
    word: "ginseng",
    phonetic: "[\u0292ins\u03b5\u014b]",
    type: "",
    translation: "n.m. \u4eba\u53c2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 97,
    word: "glace",
    phonetic: "[glas]",
    type: "",
    translation: "n.f. \u51b0\uff1b\u51b0\u5757\uff1b\u51b0\u6dc7\u6dcb\uff1b\u73bb\u7483\uff1b\u955c\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 98,
    word: "glutamate",
    phonetic: "[glytamat]",
    type: "",
    translation: "n.m. \u3010\u5316\u5b66\u3011\u8c37\u6c28\u9178\u76d0\uff08\u916f\u6216\u6839\uff09\uff0c \u5473\u7cbe",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 99,
    word: "grenouille",
    phonetic: "[gr\u0259nuj]",
    type: "",
    translation: "n.f. \u86d9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 100,
    word: "griller",
    phonetic: "[grije]",
    type: "",
    translation: "v.t. \u70e4\uff0c\u70d8\uff1b\u5e72\u7092\uff1b\u4f7f\u5e72\u67af\uff1b\u70e7\u6bc1\uff1bv.i. \u70e4\uff0c\u70d8 a. \u8102\u80aa\u7684\uff1b\u542b\u8102\u80aa\u7684\uff1b\u6cb9\u817b\u7684\uff1b\u6cb9\u6027\u7684\uff1b[\u5370]\u7c97\u4f53\u7684\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 101,
    word: "gras",
    phonetic: "[gr\u0251, -s]",
    type: "",
    translation: "n.m. \u80a5\u8089",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 102,
    word: "hareng",
    phonetic: "[ar\u0251\u0303]",
    type: "",
    translation: "\u865a\u97f3H n.m. \u9cb1\u9c7c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 103,
    word: "haricot",
    phonetic: "[ariko]",
    type: "",
    translation: "\u865a\u97f3H n.m. \u83dc\u8c46\u5c5e\u690d\u7269\uff1b\u83dc\u8c46\uff0c\u56db\u5b63\u8c46\uff0c\u6241\u8c46",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 104,
    word: "vert",
    phonetic: "[v\u03b5r, -t]",
    type: "",
    translation: "a. \u7eff\uff08\u8272\uff09\u7684\uff1b\u672a\u719f\u7684\uff0c\u751f\u7684\uff1b\u751f\u6001\u8fd0\u52a8\u7684\uff0c\u7eff\u515a\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 105,
    word: "holothurie",
    phonetic: "[\u0254l\u0254tyri]",
    type: "",
    translation: "n.f. \u6d77\u53c2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 106,
    word: "homard",
    phonetic: "[\u0254mar]",
    type: "",
    translation: "\u865a\u97f3H n.m. \u87af\u867e\uff0c\u9f99\u867e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 107,
    word: "plateau",
    phonetic: "[plato]",
    type: "",
    translation: "n.m. \u6258\u76d8\uff0c\u76d8\u5b50\uff1b\u9ad8\u539f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 108,
    word: "huile",
    phonetic: "[\u0265il]",
    type: "",
    translation: "n.f. \u6cb9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 109,
    word: "olive",
    phonetic: "[\u0254liv]",
    type: "",
    translation: "n.f. \u6cb9\u6a44\u6984\uff1b\u6a44\u6984\u5f62\u7684\u4e1c\u897f\uff1ba. inv. \u6a44\u6984\u7eff\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 110,
    word: "hu\u00eetre",
    phonetic: "[\u0265itr]",
    type: "",
    translation: "n.f. \u7261\u86ce\uff0c\u869d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 111,
    word: "s\u00e9same",
    phonetic: "[sezam]",
    type: "",
    translation: "n.m. \u829d\u9ebb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 112,
    word: "soja",
    phonetic: "[s\u0254\u0292a]",
    type: "",
    translation: "n.m. \u5927\u8c46\uff0c\u9ec4\u8c46",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 113,
    word: "igname",
    phonetic: "[i\u0272am]",
    type: "",
    translation: "n.f. \u85af",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 114,
    word: "intestin",
    phonetic: "[\u025b\u0303t\u03b5st\u025b\u0303, -in]",
    type: "",
    translation: "n.m. [\u89e3]\u80a0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 115,
    word: "colza",
    phonetic: "[k\u0254lza]",
    type: "",
    translation: "n.m. \u6cb9\u83dc\uff0c\u82b8\u85b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 116,
    word: "tournesol",
    phonetic: "[turn\u0259s\u0254l]",
    type: "",
    translation: "n.m. \u5411\u65e5\u8475",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 117,
    word: "mauve",
    phonetic: "[mov]",
    type: "",
    translation: "n.f. \u6de1\u7d2b\u8272\uff1b\u9526\u8475",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 118,
    word: "ma\u00efs",
    phonetic: "[mais]",
    type: "",
    translation: "n.m. \u7389\u7c73",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 119,
    word: "pop-corn",
    phonetic: "[p\u0254pk\u0254rn]",
    type: "",
    translation: "n.m.\uff0c n.inv. \u7206\u7c73\u82b1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 120,
    word: "jambon",
    phonetic: "[\u0292\u0251\u0303b\u0254\u0303]",
    type: "",
    translation: "n.m. \u732a\u8098\u5b50\u8089\uff1b\u706b\u817f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 121,
    word: "jambonneau",
    phonetic: "[\u0292\u0251\u0303b\u0254no]",
    type: "",
    translation: "n.m. \uff08\u732a\uff09\u8098\u5b50\uff0c\u811a\u5708\uff1b\u3010\u52a8\u3011\u6c5f\u73e7\u7684\u4fd7\u79f0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 122,
    word: "jus",
    phonetic: "[\u0292y]",
    type: "",
    translation: "n.m. \u6c41\uff0c\u6db2\uff1b\u679c\u6c41\u996e\u6599\uff0c\u852c\u83dc\u6c41\u996e\u6599",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 123,
    word: "kaki",
    phonetic: "[kaki]",
    type: "",
    translation: "a. inv. \u9ec4\u8910\u8272\u7684\uff0c\u571f\u9ec4\u8272\u7684\uff1bn.m. inv. \u9ec4\u8910\u8272\uff0c\u571f\u9ec4\u8272",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 124,
    word: "laitue",
    phonetic: "[l\u03b5ty]",
    type: "",
    translation: "ou [lety] n.f. \u83b4\u82e3\uff1b\u53f6\u7528\u83b4\u82e3\uff0c\u751f\u83dc\uff1b\u62cc\u751f\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 125,
    word: "lapin",
    phonetic: "[lap\u025b\u0303]",
    type: "",
    translation: "n. \u5154\uff1b\u5154\u8089",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 126,
    word: "langouste",
    phonetic: "[l\u0251\u0303gust]",
    type: "",
    translation: "n.f. \u9f99\u867e 3 of 7 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 127,
    word: "langue",
    phonetic: "[l\u0251\u0303g]",
    type: "",
    translation: "n.f. \u8bed\u8a00\uff1b\u820c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 128,
    word: "lard",
    phonetic: "[lar]",
    type: "",
    translation: "n.m. \u732a\u8198\uff0c\u80a5\u8089 adj. \u814c\u5236\u7684\uff1b \u814c\u6ce1\u7684\uff0c \u918b\u6e0d\u7684\uff1b\u88ab\u6d77\u6c34\u6d78\u8fc7\u7684\uff0c \u906d\u53d7\u6d77",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 129,
    word: "marin\u00e9",
    phonetic: "[marine]",
    type: "",
    translation: "\u635f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 130,
    word: "vinaigre",
    phonetic: "[vin\u03b5gr]",
    type: "",
    translation: "n.m. \u918b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 131,
    word: "mandarine",
    phonetic: "[m\u0251\u0303darin]",
    type: "",
    translation: "n.f. \u67d1\u6854\uff0c\u6a58\u67d1\uff0c\u6854\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 132,
    word: "mangue",
    phonetic: "[m\u0251\u0303g]",
    type: "",
    translation: "n.f. \u8292\u679c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 133,
    word: "manioc",
    phonetic: "[manj\u0254k]",
    type: "",
    translation: "n.m. \u6728\u85af n.m. \u9760\u5973\u4eba\u5356\u6deb\u4e3a\u751f\u7684\u4eba\uff1b\u4e3a\u5993\u5973\u62c9\u5ba2\u7684\u4eba\uff1b\u9760\u5993\u5973\u517b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 134,
    word: "maquereau",
    phonetic: "[makro]",
    type: "",
    translation: "\u6d3b\u7684\u7537\u4eba\uff0c\u6748\u6746\uff1b\u9e28\u6bcd\uff0c\u5993\u9662\u5973\u8001\u677f\uff1bpl.\u9cad",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 135,
    word: "Marmite",
    phonetic: "[marmit]",
    type: "",
    translation: "n.f. \u9505",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 136,
    word: "pot",
    phonetic: "[po]",
    type: "",
    translation: "n.m. \u7f50\uff0c\u58f6\uff0c\u575b\uff1b\u9152\u676f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 137,
    word: "chaudron",
    phonetic: "[\u222bodr\u0254\u0303]",
    type: "",
    translation: "n.m. \u5c0f\u9505\uff0c\u624b\u63d0\u9505\uff1b\u5c0f\u9505\u4e4b\u91cf\uff1b\u52a3\u8d28\u94a2\u7434\uff1b\u52a3\u8d28\u4e50\u5668",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 138,
    word: "bouilli",
    phonetic: "[buji]",
    type: "",
    translation: "adj. \u716e\u6cb8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 139,
    word: "mouton",
    phonetic: "[mut\u0254\u0303]",
    type: "",
    translation: "n.m. \u7f8a\uff0c\u7ef5\u7f8a\uff1b\u7f8a\u8089",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 140,
    word: "bouillant",
    phonetic: "[buj\u0251\u0303, -t]",
    type: "",
    translation: "a. \u6cb8\u6eda\u7684\uff0c\u716e\u6cb8\u7684\uff1b\u6fc0\u60c5\u7684\uff0c\u70ed\u60c5\u7684\uff1b\u6025\u8e81\u7684\uff0c\u66b4\u8e81\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 141,
    word: "m\u00e9duse",
    phonetic: "[medyz]",
    type: "",
    translation: "n.f.\uff0c n.pr. \u6c34\u6bcd\uff0c\u6d77\u8707",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 142,
    word: "melon",
    phonetic: "[m(\u0259)l\u0254\u0303]",
    type: "",
    translation: "n.m. \u751c\u74dc adj. \u82b3\u9999\u7684\uff0c \u6709\u9999\u5473\u7684\uff0c \u9999\u55b7\u55b7\u7684\uff1b\u52a0\u9999\u6599\u7684\uff0c \u52a0\u9999\u7cbe",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 143,
    word: "parfum\u00e9",
    phonetic: "[parfyme]",
    type: "",
    translation: "\u7684\uff1b\u6d12\u8fc7\u9999\u6c34\u7684[\u6307\u4eba]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 144,
    word: "cucurbitac\u00e9es",
    phonetic: "[kykyrbitase]",
    type: "",
    translation: "n.f.\uff0c n.pl. \uff08\u846b\u82a6\uff09\u74dc\uff1b \u846b\u82a6\u79d1 a. \u5c0f\u7684\uff0c\u7ec6\u7684\uff1b\u5fae\u5c0f\u7684\uff0c\u7ec6\u5fae\u7684\uff1bn.m. \u83dc\u5355\uff1b\uff08\u4ef7\u683c\u56fa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 145,
    word: "menu",
    phonetic: "[m\u0259ny]",
    type: "",
    translation: "\u5b9a\u7684\uff09\u5957\u9910",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 146,
    word: "millet",
    phonetic: "[mij\u03b5]",
    type: "",
    translation: "n.m. \u9ecd\uff1b\u7a37\uff1b\u5c0f\u7c73",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 147,
    word: "moule",
    phonetic: "[mul]",
    type: "",
    translation: "n.m. \u6a21\u5b50\uff0c\u94f8\u6a21\uff1b\u6a21\u578b\uff1bn.f. \u8d3b\u8d1d\uff0c\u6de1\u83dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 148,
    word: "coque",
    phonetic: "[k\u0254k]",
    type: "",
    translation: "n.f. \u679c\u58f3\uff1b\u7ed3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 149,
    word: "coquille",
    phonetic: "[k\u0254kij]",
    type: "",
    translation: "n.f. \u8d1d\u58f3\uff0c\u7532\u58f3\uff1b\u86cb\u58f3\uff1b\u679c\u58f3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 150,
    word: "carapace",
    phonetic: "[karapas]",
    type: "",
    translation: "n.f. \u7532\u58f3\uff0c\u5916\u58f3\uff0c\u80cc\u7532\uff1b\u4fdd\u62a4\u5c42\uff1b\u7532",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 151,
    word: "moutarde",
    phonetic: "[mutard]",
    type: "",
    translation: "n.f. \u82a5\u83dc\uff1b\u82a5\u672b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 152,
    word: "poudre",
    phonetic: "[pudr]",
    type: "",
    translation: "n.f. \u7c89\uff0c\u7c89\u672b\uff1b\u9999\u7c89\uff1b\u706b\u836f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 153,
    word: "agneau",
    phonetic: "[a\u0272o]",
    type: "",
    translation: "n.m. \u7f94\u7f8a\uff1b\u7f94\u7f8a\u8089",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 154,
    word: "morue",
    phonetic: "[m\u0254ry]",
    type: "",
    translation: "n.f. \u9cd5\u9c7c\uff1b[\u6c11]\u5a3c\u5993\uff1b \u5a4a\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 155,
    word: "navet",
    phonetic: "[nav\u03b5]",
    type: "",
    translation: "n.m. \u841d\u535c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 156,
    word: "noix",
    phonetic: "[nwa]",
    type: "",
    translation: "n.f. \u6838\u6843\uff1b\u7c7b\u4f3c\u6838\u6843\u7684\u679c\u5b9e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 157,
    word: "noyau",
    phonetic: "[nwajo]",
    type: "",
    translation: "n.m. \u679c\u6838\uff1b\u6838\uff1b\u9aa8\u5e72\uff1b\u6838\u5fc3\u529b\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 158,
    word: "p\u00e9pin",
    phonetic: "[pep\u025b\u0303]",
    type: "",
    translation: "n.m.\uff08\u6d46\u679c\u3001\u67d1\u6a58\u7c7b\u6c34\u679c\u7684\uff09\u7c7d\uff0c\u4ec1\uff0c\u79cd\u5b50\uff1b\u96e8\u4f1e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 159,
    word: "p\u00eache",
    phonetic: "[p\u03b5\u222b]",
    type: "",
    translation: "n.f. \u6843\u5b50\uff1b\u9493\u9c7c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 160,
    word: "cerneau",
    phonetic: "[s\u03b5rno]",
    type: "",
    translation: "n.m. \u9752\u6838\u6843\uff1b \u9752\u6838\u6843\u8089 n.m.\uff0c n.f.\uff0c adj. \u6930\u5b50\uff1b\u6930\u5b50\u7ea4\u7ef4\uff1b\uff08\u65e7\u65f6\u7684\uff09\u7518\u8349\u67e0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 161,
    word: "coco",
    phonetic: "[k\u0254ko]",
    type: "",
    translation: "\u6aac\u9732\uff1b\u86cb\uff1b\u53e4\u67ef\u78b1\uff0c \u53ef\u5361\u56e0[coca\u00efne\u7684\u7f29\u5199] 162 nouilles \u9762\u6761",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 162,
    word: "soupe",
    phonetic: "[sup]",
    type: "",
    translation: "n.f. \u6d53\u6c64\uff0c\u7fb9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 163,
    word: "\u0153uf",
    phonetic: "[\u0153f]",
    type: "",
    translation: "n.m. \u53d7\u7cbe\u5375\uff1b\u5375\u5b50\uff1b\u86cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 164,
    word: "sal\u00e9",
    phonetic: "[sale]",
    type: "",
    translation: "a. \u542b\u76d0\u7684\uff1b\u54b8\u7684\uff1b\u76d0\u6e0d\u7684\uff0c\u814c\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 165,
    word: "oie",
    phonetic: "[wa]",
    type: "",
    translation: "n.f. \u9e45\uff1b\u6bcd\u9e45\uff1b\u50bb\u74dc\uff0c\u7b28\u86cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 166,
    word: "ormeau",
    phonetic: "[\u0254rmo]",
    type: "",
    translation: "n.m. \u9c8d\u9c7c;\u5c0f\u6986\u6811 4 of 7 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. n.f. \u67d1\uff0c\u6854\uff0c\u6a59\uff1bn.m.\uff0c a. inv. \u6854\u9ec4\u8272\uff08\u7684\uff09\uff0c\u6a59\u8272",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 167,
    word: "orange",
    phonetic: "[\u0254r\u0251\u0303\u0292]",
    type: "",
    translation: "\uff08\u7684\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 168,
    word: "omelette",
    phonetic: "[\u0254ml\u03b5t]",
    type: "",
    translation: "n.f. \u714e\u86cb\u5377\uff1b\u7092\u86cb\uff0c\u644a\u9e21\u86cb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 169,
    word: "oursin",
    phonetic: "[urs\u025b\u0303]",
    type: "",
    translation: "n.m. \u6d77\u80c6\uff1b \u718a\u76ae\uff1b\u5341\u5206\u5c0f\u6c14\uff0c \u4e00\u5fd7\u4e0d\u62e8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 170,
    word: "pain",
    phonetic: "[p\u025b\u0303]",
    type: "",
    translation: "n.m. \u9762\u5305\uff1b\u98df\u7cae\uff0c\u751f\u8ba1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 171,
    word: "biscotte",
    phonetic: "[bisk\u0254t]",
    type: "",
    translation: "n.f. \u9762\u5305\u5e72\uff0c \u5e72\u9762\u5305\u7247",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 172,
    word: "grill\u00e9",
    phonetic: "[grije]",
    type: "",
    translation: "adj. \u5728\u70e4\u67b6\u4e0a\u70e4\u7684\uff1b\u88c5\u6709\u6805\u680f\u7684\uff0c \u7528\u6805\u680f\u56f4\u8d77\u6765\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 173,
    word: "vapeur",
    phonetic: "[vap\u0153r]",
    type: "",
    translation: "n.f. \u84b8\u6c14\uff1b\u84b8\u6c7d\uff0c\u6c7d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 174,
    word: "palourde",
    phonetic: "[palurd]",
    type: "",
    translation: "n.f. \u86e4\uff0c\u86b6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 175,
    word: "pamplemousse",
    phonetic: "[p\u0251\u0303pl\u0259mus]",
    type: "",
    translation: "n.m. \u67da\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 176,
    word: "papaye",
    phonetic: "[papaj]",
    type: "",
    translation: "n.f. \u756a\u6728\u74dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 177,
    word: "past\u00e8que",
    phonetic: "[past\u03b5k]",
    type: "",
    translation: "n.f. \u897f\u74dc n.f. \u6746\uff0c\u6491\u7aff\uff0c\u7bd9\uff1b\u6d4b\u91cf\u7aff\uff1b\u9493\u7aff\uff1b\u7626\u957f\u7684\u4eba\uff1b\u6709\u53c9\u7684\u9e7f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 178,
    word: "perche",
    phonetic: "[p\u03b5r\u222b]",
    type: "",
    translation: "\u89d2\uff1b\u6cd5\u56fd\u65e7\u957f\u5ea6\u5355\u4f4d\uff1b\u6cd5\u56fd\u65e7\u571f\u5730\u9762\u79ef\u5355\u4f4d\uff1b\uff08\u8fd0\u9001\u6ed1\u96ea \u8005\u4e0a\u5c71\u7684\u7535\u52a8\uff09\u540a\u6905\uff1b\u9c88\u9c7c\uff1b\u9001\u8bdd\u5668\u67b6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 179,
    word: "persil",
    phonetic: "[p\u03b5rsi]",
    type: "",
    translation: "ou [p\u03b5rsil] n.m. \u9999\u82b9\uff0c \u6b27\u82b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 180,
    word: "p\u00e9toncle",
    phonetic: "[pet\u0254\u0303kl]",
    type: "",
    translation: "n.m. \u6247\u8d1d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 181,
    word: "pieuvre",
    phonetic: "[pj\u0153vr]",
    type: "",
    translation: "n.f. \u7ae0\u9c7c\uff1b\u8d2a\u5f97\u65e0\u538c\u7684\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 182,
    word: "pigeon",
    phonetic: "[pi\u0292\u0254\u0303]",
    type: "",
    translation: "n.m. \u9e3d\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 183,
    word: "piment",
    phonetic: "[pim\u0251\u0303]",
    type: "",
    translation: "n.m. \u8fa3\u6912\uff1b\u523a\u6fc0\u6027\u7684\u4e1c\u897f\uff1b\u7325\u4eb5\u7684\u6210\u5206 a. \u51b7\u7684\uff1b\u51b7\u5374\u7684\uff1b\u51b7\u9759\u7684\uff1b\u65e0\u52a8\u4e8e\u8877\u7684\uff0c\u51b7\u6de1\u7684\uff1bn.m.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 184,
    word: "froid",
    phonetic: "[frwa, -d]",
    type: "",
    translation: "\u51b7\uff0c\u5bd2\u51b7\uff1b\u51b7\u7684\u611f\u89c9\uff1b\u51b7\u6de1\uff0c\u758f\u8fdc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 185,
    word: "poire",
    phonetic: "[pwar]",
    type: "",
    translation: "n.f. \u68a8\uff1b\u68a8\u5f62\u7269 n.m. \u70df\u718f\u7684\uff0c \u718f\u5236\u7684\uff1b\u88ab\u70df\u718f\u9ed1\u7684\uff1a\u65bd\u8fc7\u53a9\u80a5\u7684\uff0c \u65bd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 186,
    word: "fum\u00e9",
    phonetic: "[fyme]",
    type: "",
    translation: "\u8fc7\u80a5\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 187,
    word: "poireau",
    phonetic: "[pwaro]",
    type: "",
    translation: "n.m. \u97ed\u83dc\uff0c \u8471",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 188,
    word: "poivre",
    phonetic: "[pwavr]",
    type: "",
    translation: "n.m. \u80e1\u6912\uff1b\u80e1\u6912\u7c89",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 189,
    word: "poivron",
    phonetic: "[pwavr\u0254\u0303]",
    type: "",
    translation: "n.m. \u751c\u6912\uff1b\u67ff\u5b50\u6912",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 190,
    word: "pomme",
    phonetic: "[p\u0254m]",
    type: "",
    translation: "n.f. \u82f9\u679c\uff1b\u82f9\u679c\u5f62\u7269\u4f53 192 pomme de terre [p\u0254md\u0259t\u03b5r] n.f. \u571f\u8c46\uff0c\u9a6c\u94c3\u85af n.f.\uff08\u7ec7\u7269\u3001\u7eb8\u7b49\u505a\u6210\u7684\uff09\u5e26\uff0c\u5f55\u97f3\u5e26\uff1b\u957f\u6761\uff0c\u5e26\u72b6\u7269\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 191,
    word: "bande",
    phonetic: "[b\u0251\u0303d]",
    type: "",
    translation: "\u7fa4\uff0c\u961f\uff1b\u5e2e\uff0c\u4f19\uff0c\u96c6\u56e2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 192,
    word: "porc",
    phonetic: "[p\u0254r]",
    type: "",
    translation: "n.m. \u732a\uff1b\u732a\u8089\uff1b\u732a\u76ae",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 193,
    word: "potage",
    phonetic: "[p\u0254ta\u0292]",
    type: "",
    translation: "n.m.\uff08\u7528\u8089\u3001\u852c\u83dc\u7b49\u505a\u6210\u7684\uff09\u6d53\u6c64",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 194,
    word: "potiron",
    phonetic: "[p\u0254tir\u0254\u0303]",
    type: "",
    translation: "n.m. \u5927\u5357\u74dc\uff0c \u7b0b\u74dc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 195,
    word: "poule",
    phonetic: "[pul]",
    type: "",
    translation: "n.f. \u6bcd\u9e21",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 196,
    word: "poulet",
    phonetic: "[pul\u03b5]",
    type: "",
    translation: "n.m. \u5c0f\u9e21\uff1b\u6bcd\u9e21\u8089\uff1b\u7ae5\u5b50\u9e21\u8089",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 197,
    word: "poumon",
    phonetic: "[pum\u0254\u0303]",
    type: "",
    translation: "n.m. \u80ba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 198,
    word: "produit",
    phonetic: "[pr\u0254d\u0265i]",
    type: "",
    translation: "n.m. \u4ea7\u54c1\uff1b\u4ea7\u7269\uff1b\u6536\u5165\uff0c\u6536\u76ca\uff1b\u5229\u6da6\uff0c\u8d62\u5229",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 199,
    word: "alimentaire",
    phonetic: "[alim\u0251\u0303t\u03b5r]",
    type: "",
    translation: "a. \u98df\u7269\u7684\uff1b\u98df\u7528\u7684\uff1b\u996e\u98df\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 200,
    word: "prune",
    phonetic: "[pryn]",
    type: "",
    translation: "n.f. \u674e\uff0c\u674e\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 201,
    word: "pruneau",
    phonetic: "[pryno]",
    type: "",
    translation: "n.m. \u674e\u5b50\u5e72\uff1b\u9ed1\u76ae\u80a4\u7684\u4eba\uff1b\u67aa\u5f39\uff0c \u5b50\u5f39 a. \u5e72\u7684\uff1b\u5e72\u71e5\u7684\uff0c\u5e72\u65f1\u7684\uff1b\u5e72\u67af\u7684\uff1b\u4e0d\u52a0\u6c34\u7684\uff1b\u67af\u71e5\u4e4f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 202,
    word: "sec",
    phonetic: "[s\u03b5k, s\u03b5\u222b]",
    type: "",
    translation: "\u5473\u7684\uff1b\u51b7\u9177\u7684\uff1b\u751f\u786c\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 203,
    word: "confit",
    phonetic: "[k\u0254\u0303fi, -t]",
    type: "",
    translation: "adj.\u7cd6\u6e0d\u7684\uff0c\u7cd6\u716e\u7684\uff1b\u918b\u6ce1\u7684\uff1b\u6cb9\u6d78\u7684 n.m. \u7116\u8089\u51bb n.m.\uff0c n.inv. \u56db\u5408\u7cd5[\u7b49\u91cf\u7684\u9762\u7c89\u3001\u7cd6\u3001\u9ec4\u6cb9\u548c\u9e21\u86cb\u505a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 204,
    word: "quatre-quarts",
    phonetic: "[katkar]",
    type: "",
    translation: "\u6210] 5 of 7 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 205,
    word: "queue",
    phonetic: "[k\u00f8]",
    type: "",
    translation: "n.f. \u5c3e\uff0c\u5c3e\u5df4\uff1b\u7b49\u5019\u7684\u884c\u5217\uff0c\u961f\u4f0d n.m.\uff08\u52a8\u7269\u7684\uff09\u6bdb\uff1b\uff08\u4eba\u4f53\u4e0a\u7684\uff09\u6c57\u6bdb\uff1b\uff08\u7ec7\u7269\u7684\uff09\u7ed2",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 206,
    word: "poil",
    phonetic: "[pwal]",
    type: "",
    translation: "\u6bdb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 207,
    word: "raisin",
    phonetic: "[r\u03b5z\u025b\u0303]",
    type: "",
    translation: "n.m. \u8461\u8404",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 208,
    word: "vin",
    phonetic: "[v\u025b\u0303]",
    type: "",
    translation: "n.m. \u8461\u8404\u9152",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 209,
    word: "rave",
    phonetic: "[rav]",
    type: "",
    translation: "n.f. \u841d\u535c\uff1b\u829c\u83c1\uff0c\u82e4\u84dd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 210,
    word: "ravioli",
    phonetic: "[ravj\u0254li]",
    type: "",
    translation: "n.m. \u997a\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 211,
    word: "rein",
    phonetic: "[r\u025b\u0303]",
    type: "",
    translation: "n.m. \u80be\uff0c\u80be\u810f\uff1bpl. \u8170\uff0c\u8170\u90e8",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 212,
    word: "visc\u00e8res",
    phonetic: "[vis\u03b5r]",
    type: "",
    translation: "\u5185\u5bb9\uff1b \u80a0\uff1b \u5185\u810f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 213,
    word: "requin",
    phonetic: "[r(\u0259)k\u025b\u0303]",
    type: "",
    translation: "n.m. \u9ca8\uff0c \u9ca8\u9c7c\uff0c \u9c9b \uff1b\u8d2a\u5a6a\u51b7\u9177\u7684\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 214,
    word: "gluant",
    phonetic: "[gly\u0251\u0303, -t]",
    type: "",
    translation: "a. \u9ecf\u7684\uff0c\u9ecf\u6027\u7684\uff0c\u80f6\u9ecf\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 215,
    word: "restaurant",
    phonetic: "[r\u03b5st\u0254r\u0251\u0303]",
    type: "",
    translation: "n.m. \u996d\u5e97\uff0c\u9910\u9986",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 216,
    word: "manger",
    phonetic: "[m\u0251\u0303\u0292e]",
    type: "",
    translation: "v.t. \u5403\uff1b\u5403\u996d\uff0c\u5403\u4e1c\u897f\uff1b\u86c0\u98df\uff1b\u8150\u8680",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 217,
    word: "riz",
    phonetic: "[ri]",
    type: "",
    translation: "n.m. \u6c34\u7a3b\uff1b\u7c73\uff1b\u7c73\u996d adj. \u719f\u7684\uff0c \u716e\u8fc7\u7684\uff0c \u70e7\u8fc7\u7684\uff1b\u7119\u70e7\u8fc7\u7684\uff1b\u559d\u9189\u7684\uff0c \u9152\u9189",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 218,
    word: "cuit",
    phonetic: "[k\u0265i, -t]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 219,
    word: "r\u00f4tir",
    phonetic: "[r\u0254tir, ro-]",
    type: "",
    translation: "v.t. \u70e4\uff0c\u70d8\uff1b\u4f7f\u67af\u7126",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 220,
    word: "r\u00f4ti",
    phonetic: "[r\u0254ti, ro-]",
    type: "",
    translation: "a. \u70e4\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 221,
    word: "rosbif",
    phonetic: "[r\u0254sbif]",
    type: "",
    translation: "n.m. \u70e4\u725b\u8089\uff1b\u82f1\u56fd\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 222,
    word: "rouleau",
    phonetic: "[rulo]",
    type: "",
    translation: "n.m. \u6eda\u7b52\uff0c\u8f8a\uff0c\u6eda\u68d2\uff1b\u5377\uff1b\u78d9\u5b50",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 223,
    word: "saindoux",
    phonetic: "[s\u025b\u0303du]",
    type: "",
    translation: "n.m. \uff08\u71ac\u719f\u7684\uff09\u732a\u6cb9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 224,
    word: "salade",
    phonetic: "[salad]",
    type: "",
    translation: "n.f. \u51c9\u62cc\u751f\u83dc\uff1b\u751f\u83dc\uff1b\u51b7\u76d8\uff1b\u8272\u62c9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 225,
    word: "sauce",
    phonetic: "[sos]",
    type: "",
    translation: "n.f. \u8c03\u5473\u6c41\uff0c\u9171\u6cb9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 226,
    word: "saucisse",
    phonetic: "[sosis]",
    type: "",
    translation: "n.f. \u7ea2\u80a0\uff0c\u9999\u80a0\uff0c\u814a\u80a0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 227,
    word: "saucisson",
    phonetic: "[sosis\u0254\u0303]",
    type: "",
    translation: "n.m. \u7c97\u7ea2\u80a0\uff0c\u5927\u704c\u80a0",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 228,
    word: "saumon",
    phonetic: "[som\u0254\u0303]",
    type: "",
    translation: "n.m. \u9c91\u9c7c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 229,
    word: "saut\u00e9",
    phonetic: "[sote]",
    type: "",
    translation: "adj. \u7528\u6cb9\u7092\u7684\u98df\u7269\uff0c \u5ae9\u714e\u7684\u98df\u7269\uff1b\u7092\u7684\uff0c \u5ae9\u714e\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 230,
    word: "scorpion",
    phonetic: "[sk\u0254rpj\u0254\u0303]",
    type: "",
    translation: "n.m. \u874e\u5b50\uff1b le S\uff5e \u5929\u874e\u5ea7\uff1b 233 s\u00e9ch\u00e9 \u5e72\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 231,
    word: "seiche",
    phonetic: "[s\u03b5\u222b]",
    type: "",
    translation: "n.f. [\u52a8]\u58a8\u9c7c\uff0c\u4e4c\u8d3c\uff1b[\u5730]\u6e56\u9762\u6ce2\u52a8\uff0c\u6e56\u9707\uff0c\u5047\u6f6e",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 232,
    word: "seau",
    phonetic: "[so]",
    type: "",
    translation: "n.m. \u6c34\u6876\uff1b\u6876\uff1b\u4e00\u6876\u4e4b\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 233,
    word: "sel",
    phonetic: "[s\u03b5l]",
    type: "",
    translation: "n.m. \u76d0\uff1b\u98ce\u8da3\uff0c\u5999\u8da3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 234,
    word: "table",
    phonetic: "[tabl]",
    type: "",
    translation: "n.f. \u684c\u5b50\uff0c\u53f0\u5b50\uff1b\u9910\u684c\uff1b\u5e73\u53f0\uff1b\u6570\u636e\u8868\uff1b\u4e00\u89c8\u8868",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 235,
    word: "serpent",
    phonetic: "[s\u03b5rp\u0251\u0303]",
    type: "",
    translation: "n.m. \u86c7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 236,
    word: "sali\u00e8re",
    phonetic: "[salj\u03b5r]",
    type: "",
    translation: "n.f. \u76d0\u74f6\uff0c\u76d0\u76c5\uff1b\u9a6c\u7684\u773c\u7a9d\uff1b\u9501\u9aa8\u4e0a\u7a9d v.t. \u4e3a\u2026\u2026\u670d\u52a1\uff0c\u4e3a\u2026\u2026\u6548\u529b\uff1b\u670d\u4f8d\uff1b\u4f3a\u5019\u5403\u996d\uff1b\u63a5\u5f85\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 237,
    word: "servir",
    phonetic: "[s\u03b5rvir]",
    type: "",
    translation: "\u7aef\u4e0a\uff08\u996d\u83dc\uff09\uff0c\u4f9b\u5e94 n.m. [\u751f]\u80da\uff0c\u80da\u539f\u57fa\uff1b\u80da\u82bd\uff1b[\u690d]\u82bd\uff1b[\u533b]\u75c5\u83cc\uff1b\u8d77\u6e90\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 238,
    word: "germe",
    phonetic: "[\u0292\u03b5rm]",
    type: "",
    translation: "\u6839\u6e90",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 239,
    word: "sirop",
    phonetic: "[siro]",
    type: "",
    translation: "n.m. \u7cd6\u6d46\uff1b\u7cd6\u6c41 n.f. [\u6280]\u5e95\u677f\uff1b\uff08\u5e73\u5e95\u8239\u7684\uff09\u8239\u5e95\uff1b[\u91c7]\u5e73\u5df7\u5e95\uff1b \u5e95\u6881\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 240,
    word: "sole",
    phonetic: "[s\u0254l]",
    type: "",
    translation: "[\u519c]\u8f6e\u4f5c\u7530\uff1b\u9cce\uff0c \u7bac\u9cce\u9c7c\uff0c \u820c\u9cce\uff1b\uff08\u9a6c\u3001\u9a74\u7b49\u7684\uff09\u8e44\u5e95",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 241,
    word: "sorgho",
    phonetic: "[s\u0254rgo]",
    type: "",
    translation: "n.m. \u8700\u9ecd\uff0c \u9ad8\u6881 245 d\u00e9cortiqu\u00e9 \u53bb\u76ae\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 242,
    word: "bouillon",
    phonetic: "[buj\u0254\u0303]",
    type: "",
    translation: "n.m. \u8089\u6c64\uff0c\u83dc\u6c64\uff1b\uff08\u6db2\u4f53\u6cb8\u817e\u65f6\u5192\u51fa\u7684\uff09\u6c34\u6ce1\uff0c\u6c14\u6ce1 6 of 7 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. adj. \u5b8c\u7f8e\u7684\uff0c \u5b8c\u5584\u7684 2\u719f\u7ec3\u7684\uff0c \u8001\u7ec3\u7684\uff0c \u6709\u7ecf\u9a8c\u7684\uff1b\u6e05",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 243,
    word: "consomm\u00e9",
    phonetic: "[k\u0254\u0303s\u0254me]",
    type: "",
    translation: "\u7096\u8089\u6c64",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 244,
    word: "sucre",
    phonetic: "[sykr]",
    type: "",
    translation: "n.m. \u7cd6\uff1b\u7cd6\u5757\uff1b[\u5316]\u7cd6\u7c7b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 245,
    word: "sucr\u00e9",
    phonetic: "[sykre]",
    type: "",
    translation: "a. \u542b\u7cd6\u7684\uff0c\u52a0\u7cd6\u7684\uff1b\u751c\u7684\uff1b\u751c\u871c\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 246,
    word: "sucreries",
    phonetic: "[sykr\u0259ri]",
    type: "",
    translation: "n.f.\uff0c n.pl. \u751c\u98df\uff0c \u7cd6\u679c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 247,
    word: "taro",
    phonetic: "[taro]",
    type: "",
    translation: "n.m. \u828b\u5934",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 248,
    word: "tarte",
    phonetic: "[tart]",
    type: "",
    translation: "n.f. \u5976\u6cb9\u6c34\u679c\u9985\u997c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 249,
    word: "th\u00e9",
    phonetic: "[te]",
    type: "",
    translation: "n.m. \u8336\u53f6\uff1b\u8336",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 250,
    word: "jasmin",
    phonetic: "[\u0292asm\u025b\u0303]",
    type: "",
    translation: "n.m. \u8309\u8389\uff1b\u8309\u8389\u82b1\uff1b\u8309\u8389\u82b1\u9999\u7cbe",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 251,
    word: "chrysanth\u00e8me",
    phonetic: "[kriz\u0251\u0303t\u03b5m]",
    type: "",
    translation: "n.m. \u83ca\uff0c \u83ca\u82b1",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 252,
    word: "thon",
    phonetic: "[t\u0254\u0303]",
    type: "",
    translation: "n.m. \u91d1\u67aa\u9c7c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 253,
    word: "tomate",
    phonetic: "[t\u0254mat]",
    type: "",
    translation: "n.f . \u756a\u8304\uff0c\u897f\u7ea2\u67ff",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 254,
    word: "tortue",
    phonetic: "[t\u0254rty]",
    type: "",
    translation: "n.f. \u9f9f\uff0c\u4e4c\u9f9f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 255,
    word: "tripes",
    phonetic: "[trip]",
    type: "",
    translation: "\uff08\u52a8\u7269\u7684\uff09\u80a0\u5b50\uff1b\uff08\u52a8\u7269\u7684\u80a0\u5b50\u505a\u7684\uff09\u83dc\u80b4 \u8d85\u9ad8\u6e29 260 U.H.T. [ya\u0283te] Cette brique de lait utilise la technique de l'UHT. \u8fd9\u76d2\u725b\u5976\u4f7f\u7528\u4e86\u8d85\u9ad8\u6e29\u6d88\u6bd2\u6280\u672f\u3002 n.f. \u9999\u5b50\u5170\u679c\u5b9e\uff1b\u9999\u5b50\u5170\u835a\uff1b\u9999\u5b50\uff08\u9999\uff09\u7cbe\uff0c\u9999\u8349\uff08\u9999\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 256,
    word: "vanille",
    phonetic: "[vanij]",
    type: "",
    translation: "\u7cbe",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 257,
    word: "vermicelle",
    phonetic: "[v\u03b5rmis\u03b5l]",
    type: "",
    translation: "n.m. \u7ec6\u9762\u6761\uff08\u6c64\uff09\uff0c\u6302\u9762\uff08\u6c64\uff09\uff1b\u7c89\u4e1d\uff08\u6c64\uff09 a. \u7626\u7684\uff1b\u8d2b\u7620\u7684\uff1b\u5fae\u8584\u7684\uff0c\u8d2b\u4e4f\u7684\uff1b\u5e72\u762a\u7684\uff1b\u8584\u7684\uff1b\u7ec6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 258,
    word: "maigre",
    phonetic: "[m\u03b5gr]",
    type: "",
    translation: "\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 259,
    word: "hach\u00e9",
    phonetic: "['a\u222be]",
    type: "",
    translation: "\u865a\u97f3H a. \u5207\u7ec6\u7684\uff0c\u5207\u788e\u7684\uff0c\u5241\u788e\u7684\uff1b\u65ad\u65ad\u7eed\u7eed\u7684\uff0c\u4e0d\u8fde\u8d2f\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 260,
    word: "\u00e9minc\u00e9",
    phonetic: "[em\u025b\u0303se]",
    type: "",
    translation: "n.m. \u8584\u7247\uff0c \u8089\u7247",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 261,
    word: "lanier",
    phonetic: "[lanje]",
    type: "",
    translation: "n.m. \u4e00\u79cd\u96cc\u730e\u96bc",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 262,
    word: "lani\u00e8re",
    phonetic: "[lanj\u03b5r]",
    type: "",
    translation: "n.f. \u72ed\u957f\u5e26\u5b50\uff1b \u76ae\u5e26",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 263,
    word: "volaille",
    phonetic: "[v\u0254laj]",
    type: "",
    translation: "n.f. \u5bb6\u79bd\uff1b\u5bb6\u79bd\u8089",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 264,
    word: "x\u00e9r\u00e8s",
    phonetic: "[gzer\u03b5s, ks-]",
    type: "",
    translation: "n.m. \u8d6b\u96f7\u65af\u767d\u8461\u8404\u9152",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 265,
    word: "yaourt",
    phonetic: "[jaurt]",
    type: "",
    translation: "n.m. \u9178\u5976 7 of 7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
];
